import { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

const ITEMS_PER_PAGE = 10;

const FarmerTable = ({ combinedData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedState, setSelectedState] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchFpc, setSearchFpc] = useState("");

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return "bg-green-800 text-green-50";
      case "Pending":
        return "bg-red-700 text-red-50";
      case "Ongoing":
        return "bg-blue-800 text-blue-50";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const filteredFarmers = combinedData.filter((farmer) => {
    const stateMatch =
      selectedState === "All" || farmer.state === selectedState;

    const statusMatch =
      selectedStatus === "All" || farmer.droneSprayStatus === selectedStatus;

    const nameMatch =
      searchTerm === "" ||
      farmer.farmerName.toLowerCase().includes(searchTerm.toLowerCase());

    const fpcMatch =
      searchFpc === "" ||
      farmer.fpcfpoName.toLowerCase().includes(searchFpc.toLowerCase());

    return stateMatch && statusMatch && nameMatch && fpcMatch;
  });


  const totalPages = Math.ceil(filteredFarmers.length / ITEMS_PER_PAGE);
  const paginatedFarmers = filteredFarmers.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const uniqueStates = ["All", ...new Set(combinedData.map((f) => f.state))];
  const uniqueStatuses = [
    "All",
    ...new Set(combinedData.map((f) => f.droneSprayStatus)),
  ];

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE + 1;
  const endIndex = Math.min(currentPage * ITEMS_PER_PAGE, filteredFarmers.length);


  return (
    <div>
      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-4 bg-white bg-opacity-10 p-4 rounded-lg shadow-md">
        <div>
          <label className="block text-sm text-white">Filter by State</label>
          <select
            value={selectedState}
            onChange={(e) => {
              setSelectedState(e.target.value);
              setCurrentPage(1);
            }}
            className="p-2 border rounded text-sm"
          >
            {uniqueStates.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm text-white mb-1">
            Filter by Drone Status
          </label>
          <select
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e.target.value);
              setCurrentPage(1);
            }}
            className="p-2 border rounded text-sm"
          >
            {uniqueStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm text-white mb-1">
            Search by Farmer Name
          </label>
          <input
            type="text"
            placeholder="Enter farmer name"
            onChange={(e) => {
              const s = e.target.value.toLowerCase();
              setSearchTerm(s);
              setCurrentPage(1);
            }}
            className="p-2 border rounded text-sm w-full"
          />
        </div>
        <div>
          <label className="block text-sm text-white mb-1">
            Search by FPC/FPO Name
          </label>
          <input
            type="text"
            placeholder="Enter FPC/FPO name"
            onChange={(e) => {
              const s = e.target.value.toLowerCase();
              setSearchFpc(s);
              setCurrentPage(1);
            }}
            className="p-2 border rounded text-sm w-full"
          />
        </div>

      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full border text-white text-sm text-left">
         <thead className="bg-green-100 text-green-900 rounded-md">
          <tr>
            <th className="p-2">FPC/FPO Name</th>
            <th className="p-2">Farmer Name</th>
            <th className="p-2">State</th>
            <th className="p-2">District</th>
            <th className="p-2">Tehsil</th>
            <th className="p-2">Village</th>
            <th className="p-2">Crop</th>
            <th className="p-2">Area (In acres)</th>
            <th className="p-2">Spray Cycle</th>
            <th className="p-2">Date of Spraying</th>
            <th className="p-2">Crop Stage</th>
            <th className="p-2">Pest/Intervening Activity</th>
            <th className="p-2">Product Name</th>
            <th className="p-2">Dosage (ml/lt/gms/kgs)</th>
            <th className="p-2">Area Sprayed (In acres)</th>
            <th className="p-2">Drone Spray Status</th>
          </tr>
        </thead>

         <tbody>
          {paginatedFarmers.map((entry, index) => (
            <tr key={index} className="border-b hover:bg-gray-50 hover:text-gray-900">
              <td className="p-2">{entry.fpcfpoName}</td>
              <td className="p-2">{entry.farmerName}</td>
              <td className="p-2">{entry.state}</td>
              <td className="p-2">{entry.district}</td>
              <td className="p-2">{entry.tehsil}</td>
              <td className="p-2">{entry.village}</td>
              <td className="p-2">{entry.crop}</td>
              <td className="p-2">{entry.area}</td>
              <td className="p-2">{entry.sprayCycle}</td>
              <td className="p-2">{entry.dateOfSpraying}</td>
              <td className="p-2">{entry.cropStage}</td>
              <td className="p-2">{entry.pestInterveningActivity}</td>
              <td className="p-2">{entry.productName}</td>
              <td className="p-2">{entry.dosage}</td>
              {/* <td className="p-2">
                {entry.droneSprayStatus === "Completed" ? entry.dosage : "-"}
              </td> */}
              <td className="p-2">{`${entry.areaSprayed} acres`}</td>
              {/* <td className="p-2">
                {entry.droneSprayStatus === "Completed"
                  ? `${entry.areaSprayed} acres`
                  : "-"}
              </td> */}

              <td className="p-2">
                <span className={`${getStatusColor(entry.droneSprayStatus)} p-1`}>
                  {entry.droneSprayStatus}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-end mt-3 gap-2 items-center">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="p-2 bg-yellow-600 text-white rounded-full disabled:opacity-50"
        >
          <ChevronLeftIcon className="h-5 w-5" />
        </button>

        <span className="text-white font-medium">
          {startIndex}-{endIndex} of {filteredFarmers.length.toLocaleString()}
        </span>

        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="p-2 bg-yellow-600 text-white rounded-full disabled:opacity-50"
        >
          <ChevronRightIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default FarmerTable;
